export default __webpack_public_path__ + "static/main-visual-app-builder-8aae87abafeacb00d6216677ffd4d28f.png";